import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import Landing from '../Landing/Landing';
import TypeSelector from './TypeSelector/TypeSelector';
import SlotSelector from './SlotSelector/SlotSelectorB';
import SlotSubmitter from './SlotSubmitter/SlotSubmitter';
import ResearchSubmitter from './SlotSubmitter/ResearchSubmitter';
import MethodsSubmitter from './SlotSubmitter/MethodsSubmitter';
import ISZSubmitter from './SlotSubmitter/ISZSubmitter';
import SubmitSuccess from './SubmitSuccess/SubmitSuccess';

const rs = (props) => {
  return (
    <Switch>
      <Route exact path='/'>
        <Landing />
      </Route>
      <Route path='/rs/select-type'>
        {props.termsAccepted ? <TypeSelector /> : <Redirect to="/" />}
      </Route>
      <Route path='/rs/select-slot'>
        {props.termsAccepted ? <SlotSelector /> : <Redirect to="/" />}
      </Route>
      <Route path='/rs/submit-slot'>
        {props.termsAccepted ? <SlotSubmitter /> : <Redirect to="/" />}
      </Route>
      <Route path='/rs/research-submit'>
        {props.termsAccepted ? <ResearchSubmitter /> : <Redirect to="/" />}
      </Route>
      <Route path='/rs/methods-submit'>
        {props.termsAccepted ? <MethodsSubmitter /> : <Redirect to="/" />}
      </Route>
      <Route path='/rs/isz-submit'>
        {props.termsAccepted ? <ISZSubmitter /> : <Redirect to="/" />}
      </Route>
      <Route path='/rs/success'>
        <SubmitSuccess />
      </Route>
    </Switch>
  );
};

const mapStateToProps = (state) => {
  return {
    termsAccepted: state.rs.termsAccepted
  };
};

export default connect(mapStateToProps)(rs);
